import React from 'react';
import { MultiPackageBooking } from '../../components/booking';

export const NewBooking: React.FC = () => {
  return <MultiPackageBooking userRole="sales_agent" />;
};
